import { FormSelect, FormSelectIdType, FormSelectProps } from '@systemeio/ui'
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  UseFormSetValue,
} from 'react-hook-form'

type FormSelectRhfProps<
  T extends FormSelectIdType,
  TValues extends FieldValues,
  TName extends FieldPath<TValues>,
> = Omit<FormSelectProps<T>, 'onChange' | 'value'> &
  Omit<ControllerProps<TValues, TName>, 'render'> & { setValue: UseFormSetValue<TValues> }

function FormSelectRhf<
  T extends FormSelectIdType,
  TValues extends FieldValues,
  TName extends FieldPath<TValues>,
>(props: FormSelectRhfProps<T, TValues, TName>) {
  const { setValue, control, name, rules, ...restProps } = props

  const handleChange = (value: T | undefined) => setValue(name, value as PathValue<TValues, TName>)

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <FormSelect {...restProps} value={field.value} onChange={handleChange} />
      )}
    />
  )
}

export default FormSelectRhf
